import { FormControl, FormHelperText, InputLabel, LinearProgress, MenuItem } from '@material-ui/core'
import { ErrorMessage, Field, useFormikContext } from 'formik'
import { Select } from 'formik-material-ui'
import React, { memo, useEffect, useState } from 'react'

import { fetchCerealesVariedades } from '../../../../../../../models/cereal/cereal_variedad'

export const CerealesVariedadesSelect = memo(() => {
  const [cerealesVariedades, setCerealesVariedades] = useState([])
  const [disabled, setDisabled] = useState(true)
  const [loading, setLoading] = useState(false)
  const {
    values: { cereal },
    errors: { variedad: error }
  } = useFormikContext()
  useEffect(() => {
    (async () => {
      if (cereal === undefined) {
        throw new Error('No puede utilizar el dropdown de variedad sin el dropdown de cereal en el mismo formulario')
      }
      if (cereal) {
        try {
          setLoading(true)
          setCerealesVariedades(await fetchCerealesVariedades(cereal))
          setDisabled(false)
          setLoading(false)
        } catch (error) {
          setCerealesVariedades([])
          setDisabled(true)
          setLoading(false)
        }
      }
    })()
  }, [cereal])
  return (
    <FormControl style={{ width: '100%' }} variant='outlined' error={!!error}>
      <InputLabel id='variedad-label'>Variedad</InputLabel>
      <Field
        component={Select}
        name='variedad'
        label='Variedad'
        inputProps={{
          labelId: 'variedad-label',
          id: 'variedad'
        }}
        disabled={disabled}
      >
        {cerealesVariedades.map((variedad) => (
          <MenuItem key={variedad.nombreCortoVariedad} value={variedad.nombreCortoVariedad}>{variedad.nombre}</MenuItem>
        ))}
      </Field>
      {loading && <LinearProgress />}
      <ErrorMessage name='variedad' >
        {(error) => <FormHelperText>{error}</FormHelperText>}
      </ErrorMessage>
    </FormControl>
  )
})
